import { ApiError } from "../lib/api";
import { cx } from "../lib/cx";
import { ClayButton } from "./ClayButton";

export interface ErrorStateProps {
  error?: ApiError | null;
  title?: string;
  onRetry?: () => void;
  className?: string;
  compact?: boolean;
}

function defaultTitleFor(error: ApiError | null | undefined): string {
  switch (error?.code) {
    case "unauthenticated":
      return "Anda belum masuk";
    case "forbidden":
      return "Akses ditolak";
    case "network_error":
      return "Koneksi gagal";
    case "upstream_error":
      return "Sumber data bermasalah";
    default:
      return "Gagal memuat data";
  }
}

export function ErrorState({ error, title, onRetry, className, compact = false }: ErrorStateProps) {
  const heading = title ?? defaultTitleFor(error);
  const message =
    error?.message ?? "Terjadi kesalahan yang tidak diketahui. Silakan coba lagi.";

  return (
    <div
      role="alert"
      className={cx(
        "flex flex-col items-center justify-center gap-3 text-center",
        compact ? "px-4 py-8" : "px-6 py-12",
        className,
      )}
    >
      <span className="flex h-14 w-14 items-center justify-center rounded-card bg-bg text-rose-500 shadow-clay-pressed">
        <svg
          viewBox="0 0 24 24"
          className="h-6 w-6"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M12 3 2.5 20h19L12 3Z" />
          <path d="M12 9v5M12 17.2v.1" />
        </svg>
      </span>
      <p className="text-base font-semibold text-text">{heading}</p>
      <p className="max-w-md text-sm text-muted">{message}</p>
      {error?.code ? (
        <p className="text-xs uppercase tracking-wide text-muted/70">Kode: {error.code}</p>
      ) : null}
      {onRetry ? (
        <ClayButton variant="secondary" size="sm" onClick={onRetry}>
          Coba lagi
        </ClayButton>
      ) : null}
    </div>
  );
}
